module.exports = __webpack_public_path__ + "img/rdp2.b26e70d9.jpg";